export const reservationsInclude =
	'client,client.building,salesman,salesmanVisit,salesmanVisit.products,team,organization';

export const reservationsQueryBase = {
	_limit: '25',
	_sort: 'date_from',
};
